import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { collection, deleteDoc, doc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

export default function AvailabilitySection() {
//   const [availability, setAvailability] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [newHoliday, setNewHoliday] = useState("");

  // Fixed clinic timings
  const defaultSchedule = [
    {
    day: "Monday",
    slots: [
      { start: "09:00", end: "09:00" },
    ],
    off: false,
  },
    {
      day: "Tuesday",
      slots: [
        { start: "09:00", end: "09:00" },
      ],
      off: false,
    },
    {
      day: "Wednesday",
      slots: [
        { start: "09:00", end: "09:00" },
      ],
      off: false,
    },
    {
      day: "Thursday",
      slots: [
        { start: "09:00", end: "09:00" },
      ],
      off: false,
    },
    {
      day: "Friday",
      slots: [
        { start: "09:00", end: "09:00" },
      ],
      off: false,
    },
    {
      day: "Saturday",
      slots: [
        { start: "09:00", end: "09:00" },
      ],
      off: false,
    },
    {
      day: "Sunday",
      slots: [{ start: "09:00", end: "05:00" }],
      off: false,
    },
  ];
  // Initialize state with defaultSchedule
const [availability, setAvailability] = useState(defaultSchedule);

  // 📌 Fetch or fallback to defaults
 useEffect(() => {
  const fetchData = async () => {
    try {
      const availSnap = await getDocs(collection(db, "availability"));
      if (!availSnap.empty) {
        const fetchedData = availSnap.docs.map((doc) => {
          const data = doc.data();
          return {
            ...data,
            slots: Array.isArray(data.slots) ? data.slots : [],
            off: data.off ?? false,
          };
        });

        // Ensure Mon–Sun order
        const daysOfWeek = defaultSchedule.map((d) => d.day);
        const orderedData = daysOfWeek.map(
          (day) =>
            fetchedData.find((d) => d.day === day) ||
            defaultSchedule.find((d) => d.day === day)
        );

        setAvailability(orderedData);
      }
    } catch (err) {
      console.error("Error fetching:", err);
    }
  };

  fetchData();
}, []);


  // 📌 Save availability
  const saveAvailability = async () => {
    try {
      for (let item of availability) {
        await setDoc(doc(db, "availability", item.day), item);
      }
      alert("Availability saved ✅");
    } catch (err) {
      console.error("Error saving availability:", err);
    }
  };

  // 📌 Toggle day off
  const toggleDayOff = (dayIndex, checked) => {
    const updated = [...availability];
    updated[dayIndex].off = checked;
    setAvailability(updated);
  };

  // 📌 Add holiday
  const addHoliday = async () => {
    if (!newHoliday) return;
    try {
      await setDoc(doc(db, "holidays", newHoliday), { date: newHoliday });
      setHolidays([...holidays, { id: newHoliday, date: newHoliday }]);
      setNewHoliday("");
    } catch (err) {
      console.error("Error adding holiday:", err);
    }
  };

  // 📌 Remove holiday
  const removeHoliday = async (id) => {
    try {
      await deleteDoc(doc(db, "holidays", id));
      setHolidays(holidays.filter((h) => h.id !== id));
    } catch (err) {
      console.error("Error removing holiday:", err);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold text-[#204080] mb-4">
        Doctor Availability
      </h2>

      {/* Weekly Schedule */}
      <div className="overflow-x-auto bg-white shadow rounded-lg p-4 mb-6">
        <table className="w-full text-sm border">
          <thead className="bg-[#204080] text-white">
            <tr>
              <th className="p-2 text-left">Day</th>
              <th className="p-2 text-left">Operating Hours</th>
              <th className="p-2 text-left">Day Off</th>
            </tr>
          </thead>
          <tbody>
            {availability.map((day, dayIdx) => (
              <tr key={day.day} className="border-b align-top">
                <td className="p-2 font-medium">{day.day}</td>
                <td className="p-2">
                  {day.off ? (
                    <span className="text-gray-500 italic">Day Off</span>
                  ) : (
                    <ul>
                      {day.slots.map((slot, idx) => (
                        <li key={idx}>
                          {slot.start} - {slot.end}
                        </li>
                      ))}
                    </ul>
                  )}
                </td>
                <td className="p-2">
                  <input
                    type="checkbox"
                    checked={day.off}
                    onChange={(e) => toggleDayOff(dayIdx, e.target.checked)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Button
        className="mb-8 bg-[#204080] hover:bg-[#2E5AAC] text-white"
        onClick={saveAvailability}
      >
        Save Availability
      </Button>

      {/* Holidays */}
      <h3 className="text-lg font-semibold text-[#204080] mb-3">
        Special Days / Holidays
      </h3>
      <div className="flex items-center gap-3 mb-4">
        <input
          type="date"
          value={newHoliday}
          onChange={(e) => setNewHoliday(e.target.value)}
          className="border rounded px-3 py-2"
        />
        <Button
          onClick={addHoliday}
          className="bg-green-600 hover:bg-green-700 text-white"
        >
          Add Holiday
        </Button>
      </div>

      <ul className="space-y-2">
        {holidays.map((h) => (
          <li
            key={h.id}
            className="flex justify-between items-center bg-gray-100 p-2 rounded"
          >
            <span>{h.date}</span>
            <Button
              variant="destructive"
              size="sm"
              onClick={() => removeHoliday(h.id)}
            >
              Remove
            </Button>
          </li>
        ))}
        {holidays.length === 0 && (
          <p className="text-gray-500 text-sm">No holidays set.</p>
        )}
      </ul>
    </div>
  );
}
